module.exports = function() {
  return new Worker("/" + "parcel-html-transpiler.fc3f54c9.worker.js");
};